module.exports = __webpack_public_path__ + "static/img/IMG_20160307_141322.59c50679.jpg";